/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */
import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	disabledFormControl: {
		backgroundColor: '#EEEEEE',
		cursor: 'not-allowed',
		opacity: 1
	},
	helpBlockFeedback: {
		color: '#a94442',
		textAlign: 'left'
	},
	helpBlockStrength: {
		color: '#999999',
		textAlign: 'right'
	},
	progressBar: {
		marginBottom: '0px'
	},
	progressBarHidden: {
		visibility: 'hidden'
	}
});

export default styles;
